import React from 'react'
import { Button as PaperButton } from 'react-native-paper'
import { useBaseLayoutStyle } from '../../ions/styles'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle, webSpecificStyle } = helpers

export const Button = ({ labelStyle, dense, ...props }) => {
  const { button, buttonDense } = useBaseLayoutStyle()
  return (
    <PaperButton
      {...props}
      labelStyle={composeStyle(
        labelStyle,
        dense ? buttonDense : button,
        webSpecificStyle({ userSelect: 'none' }),
      )}
    />
  )
}
